import React, { useState } from "react";
import { Select } from "antd";
import ReactPlayer from "react-player";
export default function VideoPlayer({ url, key, style }) {
  const [rate, setRate] = useState(1);
  return (
    <div key={key}>
      <ReactPlayer
        playbackRate={rate}
        url={url}
        width="100%"
        height="auto"
        controls
        style={style}
      />
      <Select onChange={(e) => setRate(e)} value={rate}>
        <Select.Option value={1}>x1</Select.Option>
        <Select.Option value={2}>x2</Select.Option>
        <Select.Option value={3}>x3</Select.Option>
        <Select.Option value={5}>x5</Select.Option>
      </Select>
    </div>
  );
}
